/* js/slider-region.js */

;(function($, window, document) {
    
    $(document).ready(function(){
       
       if (typeof $.fn.slick == 'function') {

            $('.slider-region').slick({
                autoplay: true,
                pauseOnHover: true,
                autoplaySpeed: 7000,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                infinite: true
            });
           
       }
       
    });
    
})(jQuery, window, document);